module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "input",
      "validation": "required"
    },
    model: {
      value: (_vm.input.name),
      callback: function($$v) {
        _vm.$set(_vm.input, "name", $$v)
      },
      expression: "input.name"
    }
  }), _vm._v(" "), _c('form-select', {
    ref: "type",
    attrs: {
      "label": "Type",
      "name": "type",
      "options": _vm.inputTypes,
      "validation": "required"
    },
    model: {
      value: (_vm.input.type),
      callback: function($$v) {
        _vm.$set(_vm.input, "type", $$v)
      },
      expression: "input.type"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8acb926","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/Workflows/Tasks/Input.vue
// module id = 660
// module chunks = 1